import contractorSiteDeliveryCard from '@assets/documents/def/contractorSiteDeliveryCard.webp'
import detailsOfOverheadLines from '@assets/documents/def/detailsOfOverheadLines.webp'
import excavationAndCableLayingWork from '@assets/documents/def/excavationAndCableLayingWork.webp'
import listOHInspection from '@assets/documents/def/listOHInspection.webp'
import measurementSheet from '@assets/documents/def/measurementSheet.webp'
import measurementsSheetForMeters from '@assets/documents/def/measurementsSheetForMeters.webp'
import measurementsSheetForOHNetwork from '@assets/documents/def/measurementsSheetForOHNetwork.webp'
import minipillar from '@assets/documents/def/minipillar.webp'
import overheadLineAsBuiltReportSummary from '@assets/documents/def/overheadLineAsBuiltReportSummary.webp'
import procedure190 from '@assets/documents/def/procedure190.webp'
import siteSurveyForm from '@assets/documents/def/siteSurveyForm.webp'
import splicingTermination from '@assets/documents/def/splicingTermination.webp'
import starsSafety from '@assets/documents/def/starsSafety.webp'
import substationAndElectricalEquipmentInspection from '@assets/documents/def/substationAndElectricalEquipmentInspection.webp'
import substationEarthing from '@assets/documents/def/substationEarthing.webp'
import substationFoundation from '@assets/documents/def/substationFoundation.webp'
import workSiteInspectionForm from '@assets/documents/def/workSiteInspectionForm.webp'
import lvMeterInstallation from '@assets/documents/def/lvMeterInstallation.webp'
import assets from '@assets/documents/def/assets.webp'

export const def = props => [
    {
        text: 'بطاقة تسليم الموقع للمقاول',
        image: contractorSiteDeliveryCard,
        fields: [
            {type: 't', x: 950, y: 175, w: 95, h: 45, default: props.dep, align: 'center'},
            {type: 't', x: 200, y: 175, w: 245, h: 45, default: props.div, align: 'center'},
            {type: 't', x: 890, y: 235, w: 135, h: 80, default: props.district},
            {type: 't', x: 550, y: 235, w: 205, h: 80, default: props.feeder},
            {type: 't', x: 150, y: 235, w: 235, h: 80, default: props.contractor},
            {type: 't', x: 660, y: 325, w: 200, h: 55},
            {type: 't', x: 150, y: 325, w: 320, h: 55, default: props.now_date},
            {type: 't', x: 660, y: 400, w: 200, h: 55},
            {type: 't', x: 150, y: 400, w: 300, h: 55, default: props.number},
            {type: 't', x: 920, y: 600, w: 226, h: 45},
            {type: 't', x: 350, y: 600, w: 565, h: 45, default: 'لا يوجد'},
            {type: 't', x: 240, y: 600, w: 105, h: 45},
            {type: 't', x: 140, y: 600, w: 95, h: 45},
            {type: 't', x: 920, y: 650, w: 226, h: 45},
            {type: 't', x: 350, y: 650, w: 565, h: 45},
            {type: 't', x: 240, y: 650, w: 105, h: 45},
            {type: 't', x: 140, y: 650, w: 95, h: 45},
            {type: 't', x: 920, y: 702, w: 226, h: 45},
            {type: 't', x: 350, y: 702, w: 565, h: 45},
            {type: 't', x: 240, y: 702, w: 105, h: 45},
            {type: 't', x: 140, y: 702, w: 95, h: 45},
            {type: 't', x: 920, y: 754, w: 226, h: 45},
            {type: 't', x: 350, y: 754, w: 565, h: 45},
            {type: 't', x: 240, y: 754, w: 105, h: 45},
            {type: 't', x: 140, y: 754, w: 95, h: 45},
            {type: 't', x: 920, y: 804, w: 226, h: 45},
            {type: 't', x: 350, y: 804, w: 565, h: 45},
            {type: 't', x: 240, y: 804, w: 105, h: 45},
            {type: 't', x: 140, y: 804, w: 95, h: 45},
            {type: 't', x: 920, y: 856, w: 226, h: 45},
            {type: 't', x: 350, y: 856, w: 565, h: 45},
            {type: 't', x: 240, y: 856, w: 105, h: 45},
            {type: 't', x: 140, y: 856, w: 95, h: 45},
            {type: 't', x: 920, y: 908, w: 226, h: 45},
            {type: 't', x: 350, y: 908, w: 565, h: 45},
            {type: 't', x: 240, y: 908, w: 105, h: 45},
            {type: 't', x: 140, y: 908, w: 95, h: 45},
            {type: 't', x: 920, y: 959, w: 226, h: 45},
            {type: 't', x: 350, y: 959, w: 565, h: 45},
            {type: 't', x: 240, y: 959, w: 105, h: 45},
            {type: 't', x: 140, y: 959, w: 95, h: 45},
            {type: 't', x: 920, y: 1011, w: 226, h: 45},
            {type: 't', x: 350, y: 1011, w: 565, h: 45},
            {type: 't', x: 240, y: 1011, w: 105, h: 45},
            {type: 't', x: 140, y: 1011, w: 95, h: 45},
            {type: 't', x: 920, y: 1063, w: 226, h: 45},
            {type: 't', x: 350, y: 1063, w: 565, h: 45},
            {type: 't', x: 240, y: 1063, w: 105, h: 45},
            {type: 't', x: 140, y: 1063, w: 95, h: 45},
            {type: 't', x: 920, y: 1114, w: 226, h: 45},
            {type: 't', x: 350, y: 1114, w: 565, h: 45},
            {type: 't', x: 240, y: 1114, w: 105, h: 45},
            {type: 't', x: 140, y: 1114, w: 95, h: 45},
            {type: 't', x: 735, y: 1290, w: 330, h: 30, default: props.user.name, readonly: true, align: 'center'},
            {type: 't', x: 735, y: 1365, w: 330, h: 30, default: props.supervisor.name, readonly: true, align: 'center'},
            {type: 'i', x: 275, y: 1275, w: 250, h: 65, default: props.user.signature, readonly: true},
            {type: 'i', x: 275, y: 1350, w: 250, h: 65, default: props.supervisor.signature, readonly: true},
        ]
    },
    {
        text: 'نموذج التفتيش على موقع العمل',
        image: workSiteInspectionForm,
        fields: [
            {type: 't', x: 546, y: 123, w: 425, h: 25, default: props.div},
            {type: 't', x: 84, y: 123, w: 276, h: 25, default: props.number},
            {type: 't', x: 546, y: 158, w: 425, h: 25, default: props.user.name, readonly: true},
            {type: 't', x: 84, y: 158, w: 276, h: 25},
            {type: 't', x: 546, y: 187, w: 425, h: 25, default: props.now_date},
            {type: 't', x: 84, y: 187, w: 276, h: 25, default: props.now_time},
            {type: 't', x: 84, y: 214, w: 888, h: 25, default: props.notes},
            {type: 't', x: 84, y: 248, w: 888, h: 25, default: props.contractor},
            {type: 'y', x: 507, y: 369, w: 70, h: 25, default: 'yes', group: 'g369'},
            {type: 'y', x: 433, y: 369, w: 72, h: 25, group: 'g369'},
            {type: 'y', x: 360, y: 369, w: 72, h: 25, group: 'g369'},
            {type: 't', x: 70, y: 369, w: 287, h: 25},
            {type: 'y', x: 507, y: 412, w: 70, h: 25, default: 'yes', group: 'g412'},
            {type: 'y', x: 433, y: 412, w: 72, h: 25, group: 'g412'},
            {type: 'y', x: 360, y: 412, w: 72, h: 25, group: 'g412'},
            {type: 't', x: 70, y: 412, w: 287, h: 25},
            {type: 'y', x: 507, y: 454, w: 70, h: 25, default: 'yes', group: 'g454'},
            {type: 'y', x: 433, y: 454, w: 72, h: 25, group: 'g454'},
            {type: 'y', x: 360, y: 454, w: 72, h: 25, group: 'g454'},
            {type: 't', x: 70, y: 454, w: 287, h: 25},
            {type: 'y', x: 507, y: 496, w: 70, h: 25, default: 'yes', group: 'g496'},
            {type: 'y', x: 433, y: 496, w: 72, h: 25, group: 'g496'},
            {type: 'y', x: 360, y: 496, w: 72, h: 25, group: 'g496'},
            {type: 't', x: 70, y: 496, w: 287, h: 25},
            {type: 'y', x: 507, y: 539, w: 70, h: 25, default: 'yes', group: 'g539'},
            {type: 'y', x: 433, y: 539, w: 72, h: 25, group: 'g539'},
            {type: 'y', x: 360, y: 539, w: 72, h: 25, group: 'g539'},
            {type: 't', x: 70, y: 539, w: 287, h: 25},
            {type: 'y', x: 507, y: 581, w: 70, h: 25, default: 'yes', group: 'g581'},
            {type: 'y', x: 433, y: 581, w: 72, h: 25, group: 'g581'},
            {type: 'y', x: 360, y: 581, w: 72, h: 25, group: 'g581'},
            {type: 't', x: 70, y: 581, w: 287, h: 25},
            {type: 'y', x: 507, y: 623, w: 70, h: 25, default: 'yes', group: 'g623'},
            {type: 'y', x: 433, y: 623, w: 72, h: 25, group: 'g623'},
            {type: 'y', x: 360, y: 623, w: 72, h: 25, group: 'g623'},
            {type: 't', x: 70, y: 623, w: 287, h: 25},
            {type: 'y', x: 507, y: 665, w: 70, h: 25, default: 'yes', group: 'g665'},
            {type: 'y', x: 433, y: 665, w: 72, h: 25, group: 'g665'},
            {type: 'y', x: 360, y: 665, w: 72, h: 25, group: 'g665'},
            {type: 't', x: 70, y: 665, w: 287, h: 25},
            {type: 'y', x: 507, y: 708, w: 70, h: 25, default: 'yes', group: 'g708'},
            {type: 'y', x: 433, y: 708, w: 72, h: 25, group: 'g708'},
            {type: 'y', x: 360, y: 708, w: 72, h: 25, group: 'g708'},
            {type: 't', x: 70, y: 708, w: 287, h: 25},
            {type: 'y', x: 507, y: 743, w: 70, h: 25, group: 'g743'},
            {type: 'y', x: 433, y: 743, w: 72, h: 25, group: 'g743'},
            {type: 'y', x: 360, y: 743, w: 72, h: 25, default: 'yes', group: 'g743'},
            {type: 't', x: 70, y: 743, w: 287, h: 25},
            {type: 'y', x: 507, y: 773, w: 70, h: 25, default: 'yes', group: 'g773'},
            {type: 'y', x: 433, y: 773, w: 72, h: 25, group: 'g773'},
            {type: 'y', x: 360, y: 773, w: 72, h: 25, group: 'g773'},
            {type: 't', x: 70, y: 773, w: 287, h: 25},
            {type: 'y', x: 507, y: 808, w: 70, h: 25, group: 'g808'},
            {type: 'y', x: 433, y: 808, w: 72, h: 25, group: 'g808'},
            {type: 'y', x: 360, y: 808, w: 72, h: 25, default: 'yes', group: 'g808'},
            {type: 't', x: 70, y: 808, w: 287, h: 25},
            {type: 'y', x: 507, y: 852, w: 70, h: 25, default: 'yes', group: 'g852'},
            {type: 'y', x: 433, y: 852, w: 72, h: 25, group: 'g852'},
            {type: 'y', x: 360, y: 852, w: 72, h: 25, group: 'g852'},
            {type: 't', x: 70, y: 852, w: 287, h: 25},
            {type: 'y', x: 507, y: 895, w: 70, h: 25, default: 'yes', group: 'g895'},
            {type: 'y', x: 433, y: 895, w: 72, h: 25, group: 'g895'},
            {type: 'y', x: 360, y: 895, w: 72, h: 25, group: 'g895'},
            {type: 't', x: 70, y: 895, w: 287, h: 25},
            {type: 'y', x: 507, y: 937, w: 70, h: 25, default: 'yes', group: 'g937'},
            {type: 'y', x: 433, y: 937, w: 72, h: 25, group: 'g937'},
            {type: 'y', x: 360, y: 937, w: 72, h: 25, group: 'g937'},
            {type: 't', x: 70, y: 937, w: 287, h: 25},
            {type: 'y', x: 507, y: 979, w: 70, h: 25, default: 'yes', group: 'g979'},
            {type: 'y', x: 433, y: 979, w: 72, h: 25, group: 'g979'},
            {type: 'y', x: 360, y: 979, w: 72, h: 25, group: 'g979'},
            {type: 't', x: 70, y: 979, w: 287, h: 25},
            {type: 'y', x: 507, y: 1020, w: 70, h: 25, default: 'yes', group: 'g1020'},
            {type: 'y', x: 433, y: 1020, w: 72, h: 25, group: 'g1020'},
            {type: 'y', x: 360, y: 1020, w: 72, h: 25, group: 'g1020'},
            {type: 't', x: 70, y: 1020, w: 287, h: 25},
            {type: 'y', x: 507, y: 1053, w: 70, h: 25, default: 'yes', group: 'g1053'},
            {type: 'y', x: 433, y: 1053, w: 72, h: 25, group: 'g1053'},
            {type: 'y', x: 360, y: 1053, w: 72, h: 25, group: 'g1053'},
            {type: 't', x: 70, y: 1053, w: 287, h: 25},
            {type: 'y', x: 507, y: 1089, w: 70, h: 25, default: 'yes', group: 'g1089'},
            {type: 'y', x: 433, y: 1089, w: 72, h: 25, group: 'g1089'},
            {type: 'y', x: 360, y: 1089, w: 72, h: 25, group: 'g1089'},
            {type: 't', x: 70, y: 1089, w: 287, h: 25},
            {type: 'y', x: 507, y: 1125, w: 70, h: 25, default: 'yes', group: 'g1125'},
            {type: 'y', x: 433, y: 1125, w: 72, h: 25, group: 'g1125'},
            {type: 'y', x: 360, y: 1125, w: 72, h: 25, group: 'g1125'},
            {type: 't', x: 70, y: 1125, w: 287, h: 25},
            {type: 'y', x: 507, y: 1155, w: 70, h: 25, default: 'yes', group: 'g1155'},
            {type: 'y', x: 433, y: 1155, w: 72, h: 25, group: 'g1155'},
            {type: 'y', x: 360, y: 1155, w: 72, h: 25, group: 'g1155'},
            {type: 't', x: 70, y: 1155, w: 287, h: 25},
            {type: 'y', x: 507, y: 1186, w: 70, h: 25, default: 'yes', group: 'g1186'},
            {type: 'y', x: 433, y: 1186, w: 72, h: 25, group: 'g1186'},
            {type: 'y', x: 360, y: 1186, w: 72, h: 25, group: 'g1186'},
            {type: 't', x: 70, y: 1186, w: 287, h: 25},
            {type: 'y', x: 507, y: 1219, w: 70, h: 25, default: 'yes', group: 'g1219'},
            {type: 'y', x: 433, y: 1219, w: 72, h: 25, group: 'g1219'},
            {type: 'y', x: 360, y: 1219, w: 72, h: 25, group: 'g1219'},
            {type: 't', x: 70, y: 1219, w: 287, h: 25},
            {type: 'y', x: 507, y: 1252, w: 70, h: 25, default: 'yes', group: 'g1252'},
            {type: 'y', x: 433, y: 1252, w: 72, h: 25, group: 'g1252'},
            {type: 'y', x: 360, y: 1252, w: 72, h: 25, group: 'g1252'},
            {type: 't', x: 70, y: 1252, w: 287, h: 25},
            {type: 'y', x: 507, y: 1289, w: 70, h: 25, group: 'g1289'},
            {type: 'y', x: 433, y: 1289, w: 72, h: 25, default: 'yes', group: 'g1289'},
            {type: 'y', x: 360, y: 1289, w: 72, h: 25, group: 'g1289'},
            {type: 't', x: 70, y: 1289, w: 287, h: 25},
            {type: 'y', x: 507, y: 1331, w: 70, h: 25, group: 'g1331'},
            {type: 'y', x: 433, y: 1331, w: 72, h: 25, group: 'g1331'},
            {type: 'y', x: 360, y: 1331, w: 72, h: 25, default: 'yes', group: 'g1331'},
            {type: 't', x: 70, y: 1331, w: 287, h: 25},

            {type: 't', x: 704, y: 1370, w: 300, h: 25, default: props.user.name, readonly: true},
            {type: 'i', x: 861, y: 1404, w: 200, h: 52, default: props.user.signature, readonly: true},
        ]
    },
    {
        text: 'نظام ادارة السلامة والصحة المهنية',
        image: starsSafety,
        fields: [
            {type: 'y', x: 288, y: 368, w: 65, h: 37, default: 'yes', group: 'g368'},
            {type: 'y', x: 203, y: 368, w: 82, h: 37, group: 'g368'},
            {type: 't', x: 47, y: 368, w: 154, h: 37},
            {type: 'y', x: 288, y: 408, w: 65, h: 37, default: 'yes', group: 'g408'},
            {type: 'y', x: 203, y: 408, w: 82, h: 37, group: 'g408'},
            {type: 't', x: 47, y: 408, w: 154, h: 37},
            {type: 'y', x: 288, y: 448, w: 65, h: 37, default: 'yes', group: 'g448'},
            {type: 'y', x: 203, y: 448, w: 82, h: 37, group: 'g448'},
            {type: 't', x: 47, y: 448, w: 154, h: 37},
            {type: 'y', x: 288, y: 488, w: 65, h: 37, default: 'yes', group: 'g488'},
            {type: 'y', x: 203, y: 488, w: 82, h: 37, group: 'g488'},
            {type: 't', x: 47, y: 488, w: 154, h: 37},
            {type: 'y', x: 288, y: 528, w: 65, h: 37, default: 'yes', group: 'g528'},
            {type: 'y', x: 203, y: 528, w: 82, h: 37, group: 'g528'},
            {type: 't', x: 47, y: 528, w: 154, h: 37},
            {type: 'y', x: 288, y: 568, w: 65, h: 37, default: 'yes', group: '568'},
            {type: 'y', x: 203, y: 568, w: 82, h: 37, group: '568'},
            {type: 't', x: 47, y: 568, w: 154, h: 37},
            {type: 'y', x: 288, y: 608, w: 65, h: 37, default: 'na', group: 'g608'},
            {type: 'y', x: 203, y: 608, w: 82, h: 37, group: 'g608'},
            {type: 't', x: 47, y: 608, w: 154, h: 37},
            {type: 'y', x: 288, y: 647, w: 65, h: 37, default: 'yes', group: 'g647'},
            {type: 'y', x: 203, y: 647, w: 82, h: 37, group: 'g647'},
            {type: 't', x: 47, y: 647, w: 154, h: 37},
            {type: 'y', x: 288, y: 687, w: 65, h: 37, default: 'yes', group: 'g687'},
            {type: 'y', x: 203, y: 687, w: 82, h: 37, group: 'g687'},
            {type: 't', x: 47, y: 687, w: 154, h: 37},
            {type: 'y', x: 288, y: 740, w: 65, h: 37, default: 'na', group: 'g740'},
            {type: 'y', x: 203, y: 740, w: 82, h: 37, group: 'g740'},
            {type: 't', x: 47, y: 740, w: 154, h: 37},
            {type: 'y', x: 288, y: 820, w: 65, h: 37, default: 'yes', group: 'g820'},
            {type: 'y', x: 203, y: 820, w: 82, h: 37, group: 'g820'},
            {type: 't', x: 47, y: 820, w: 154, h: 37},
            {type: 'y', x: 288, y: 886, w: 65, h: 37, default: 'yes', group: 'g886'},
            {type: 'y', x: 203, y: 886, w: 82, h: 37, group: 'g886'},
            {type: 't', x: 47, y: 886, w: 154, h: 37},
            {type: 'y', x: 288, y: 926, w: 65, h: 37, default: 'yes', group: 'g926'},
            {type: 'y', x: 203, y: 926, w: 82, h: 37, group: 'g926'},
            {type: 't', x: 47, y: 926, w: 154, h: 37},
            {type: 'y', x: 288, y: 966, w: 65, h: 37, default: 'yes', group: 'g966'},
            {type: 'y', x: 203, y: 966, w: 82, h: 37, group: 'g966'},
            {type: 't', x: 47, y: 966, w: 154, h: 37},
            {type: 'y', x: 288, y: 1006, w: 65, h: 37, default: 'yes', group: 'g1006'},
            {type: 'y', x: 203, y: 1006, w: 82, h: 37, group: 'g1006'},
            {type: 't', x: 47, y: 1006, w: 154, h: 37},
            {type: 'y', x: 288, y: 1046, w: 65, h: 37, default: 'yes', group: 'g1046'},
            {type: 'y', x: 203, y: 1046, w: 82, h: 37, group: 'g1046'},
            {type: 't', x: 47, y: 1046, w: 154, h: 37},
            {type: 'y', x: 288, y: 1085, w: 65, h: 37, default: 'yes', group: 'g1085'},
            {type: 'y', x: 203, y: 1085, w: 82, h: 37, group: 'g1085'},
            {type: 't', x: 47, y: 1085, w: 154, h: 37},
            {type: 'y', x: 288, y: 1140, w: 65, h: 37, default: 'yes', group: 'g1140'},
            {type: 'y', x: 203, y: 1140, w: 82, h: 37, group: 'g1140'},
            {type: 't', x: 47, y: 1140, w: 154, h: 37},
            {type: 'y', x: 288, y: 1192, w: 65, h: 37, default: 'yes', group: 'g1192'},
            {type: 'y', x: 203, y: 1192, w: 82, h: 37, group: 'g1192'},
            {type: 't', x: 47, y: 1192, w: 154, h: 37},
            {type: 'y', x: 288, y: 1232, w: 65, h: 37, default: 'yes', group: 'g1232'},
            {type: 'y', x: 203, y: 1232, w: 82, h: 37, group: 'g1232'},
            {type: 't', x: 47, y: 1232, w: 154, h: 37},
            {type: 'y', x: 288, y: 1271, w: 65, h: 37, default: 'yes', group: 'g1271'},
            {type: 'y', x: 203, y: 1271, w: 82, h: 37, group: 'g1271'},
            {type: 't', x: 47, y: 1271, w: 154, h: 37},
            {type: 't', x: 595, y: 1314, w: 200, h: 25, default: props.user.name, readonly: true},
            {type: 'i', x: 385, y: 1301, w: 200, h: 52, default: props.user.signature, readonly: true},
            {type: 't', x: 478, y: 1355, w: 200, h: 25, default: props.supervisor.name, readonly: true},
            {type: 'i', x: 268, y: 1349, w: 200, h: 52, default: props.supervisor.signature, readonly: true},
        ]
    },
    {
        text: 'أعمال الحفر وتمديدات الكوابل',
        image: excavationAndCableLayingWork,
        fields: [
            {type: 't', x: 1005, y: 180, w: 100, h: 30, align: 'center', default: props.dep},
            {type: 't', x: 145, y: 180, w: 210, h: 30, align: 'center', default: props.div},
            {type: 't', x: 825, y: 250, w: 355, h: 30, align: 'center', default: props.district},
            {type: 't', x: 150, y: 250, w: 375, h: 30, align: 'center', default: props.feeder},
            {type: 't', x: 825, y: 290, w: 355, h: 30, align: 'center', default: props.contractor},
            {type: 't', x: 195, y: 290, w: 315, h: 30, align: 'center', default: props.number},
            {type: 'yn', x: 616, y: 383, w: 90, h: 32, default: 'yes'},
            {type: 'yn', x: 616, y: 418, w: 90, h: 32, default: 'yes'},
            {type: 'yn', x: 616, y: 453, w: 90, h: 32, default: 'yes'},
            {type: 'yn', x: 616, y: 488, w: 90, h: 32, default: 'yes'},
            {type: 'yn', x: 616, y: 523, w: 90, h: 32, default: 'yes'},
            {type: 'yn', x: 616, y: 558, w: 90, h: 32, default: 'yes'},
            {type: 'yn', x: 616, y: 593, w: 90, h: 32, default: 'yes'},
            {type: 'yn', x: 616, y: 636, w: 90, h: 32},
            {type: 'yn', x: 616, y: 676, w: 90, h: 32},
            {type: 'yn', x: 616, y: 711, w: 90, h: 32},
            {type: 'yn', x: 616, y: 746, w: 90, h: 32},
            {type: 'yn', x: 616, y: 781, w: 90, h: 32},
            {type: 'yn', x: 616, y: 823, w: 90, h: 32},
            {type: 'yn', x: 616, y: 863, w: 90, h: 32},
            {type: 'yn', x: 616, y: 898, w: 90, h: 32},
            {type: 'yn', x: 616, y: 933, w: 90, h: 32},
            {type: 'yn', x: 616, y: 969, w: 90, h: 32},
            {type: 'yn', x: 616, y: 1004, w: 90, h: 32},
            {type: 'yn', x: 616, y: 1039, w: 90, h: 32},
            {type: 'yn', x: 616, y: 1074, w: 90, h: 32},
            {type: 'yn', x: 616, y: 1109, w: 90, h: 32},
            {type: 'yn', x: 616, y: 1144, w: 90, h: 32},
            {type: 'yn', x: 616, y: 1179, w: 90, h: 32},
            {type: 'yn', x: 616, y: 1221, w: 90, h: 32},
            {type: 'yn', x: 616, y: 1261, w: 90, h: 32},
            {type: 't', x: 800, y: 1327, w: 200, h: 35, default: props.user.name, readonly: true},
            {type: 't', x: 255, y: 1327, w: 145, h: 32, default: props.now_date},
            {type: 'i', x: 35, y: 1320, w: 200, h: 52, default: props.user.signature, readonly: true},
        ]
    },
    {
        text: 'وصلات لحام / وصلات نهاية',
        image: splicingTermination,
        fields: [
            {type: 't', x: 987, y: 243, w: 128, h: 25, default: props.dep, align: 'center'},
            {type: 't', x: 675, y: 243, w: 145, h: 25, default: props.div, align: 'center'},
            {type: 't', x: 477, y: 243, w: 60, h: 25, default: props.district, align: 'center'},
            {type: 't', x: 115, y: 248, w: 147, h: 25, default: props.number},
            {type: 'y', x: 686, y: 407, w: 63, h: 26, group: 'g407'},
            {type: 'y', x: 611, y: 407, w: 63, h: 26, group: 'g407'},
            {type: 'y', x: 686, y: 435, w: 63, h: 26, group: 'g435'},
            {type: 'y', x: 611, y: 435, w: 63, h: 26, group: 'g435'},
            {type: 'y', x: 686, y: 462, w: 63, h: 26, group: 'g462'},
            {type: 'y', x: 611, y: 462, w: 63, h: 26, group: 'g462'},
            {type: 'y', x: 686, y: 490, w: 63, h: 26, group: 'g490'},
            {type: 'y', x: 611, y: 490, w: 63, h: 26, group: 'g490'},
            {type: 'y', x: 686, y: 523, w: 63, h: 26, group: 'g523'},
            {type: 'y', x: 611, y: 523, w: 63, h: 26, group: 'g523'},
            {type: 'y', x: 686, y: 556, w: 63, h: 26, group: 'g556'},
            {type: 'y', x: 611, y: 556, w: 63, h: 26, group: 'g556'},
            {type: 'y', x: 686, y: 589, w: 63, h: 26, group: 'g589'},
            {type: 'y', x: 611, y: 589, w: 63, h: 26, group: 'g589'},
            {type: 'y', x: 686, y: 622, w: 63, h: 26, group: 'g622'},
            {type: 'y', x: 611, y: 622, w: 63, h: 26, group: 'g622'},
            {type: 'y', x: 686, y: 650, w: 63, h: 26, group: 'g650'},
            {type: 'y', x: 611, y: 650, w: 63, h: 26, group: 'g650'},
            {type: 'y', x: 686, y: 683, w: 63, h: 26, group: 'g683'},
            {type: 'y', x: 611, y: 683, w: 63, h: 26, group: 'g683'},
            {type: 'y', x: 686, y: 721, w: 63, h: 26, group: 'g721'},
            {type: 'y', x: 611, y: 721, w: 63, h: 26, group: 'g721'},
            {type: 'y', x: 686, y: 758, w: 63, h: 26, group: 'g758'},
            {type: 'y', x: 611, y: 758, w: 63, h: 26, group: 'g758'},
            {type: 'y', x: 686, y: 796, w: 63, h: 26, group: 'g796'},
            {type: 'y', x: 611, y: 796, w: 63, h: 26, group: 'g796'},
            {type: 'y', x: 686, y: 833, w: 63, h: 26, group: 'g833'},
            {type: 'y', x: 611, y: 833, w: 63, h: 26, group: 'g833'},
            {type: 'y', x: 686, y: 894, w: 63, h: 26, group: 'g894'},
            {type: 'y', x: 611, y: 894, w: 63, h: 26, default: 'yes', group: 'g894'},
            {type: 'y', x: 686, y: 922, w: 63, h: 26, group: 'g922'},
            {type: 'y', x: 611, y: 922, w: 63, h: 26, default: 'yes', group: 'g922'},
            {type: 'y', x: 686, y: 950, w: 63, h: 26, group: 'g950'},
            {type: 'y', x: 611, y: 950, w: 63, h: 26, default: 'yes', group: 'g950'},
            {type: 'y', x: 686, y: 979, w: 63, h: 26, group: 'g979'},
            {type: 'y', x: 611, y: 979, w: 63, h: 26, default: 'yes', group: 'g979'},
            {type: 'y', x: 686, y: 1007, w: 63, h: 26, group: 'g1007'},
            {type: 'y', x: 611, y: 1007, w: 63, h: 26, default: 'yes', group: 'g1007'},
            {type: 'y', x: 686, y: 1035, w: 63, h: 26, group: 'g1035'},
            {type: 'y', x: 611, y: 1035, w: 63, h: 26, default: 'yes', group: 'g1035'},
            {type: 'y', x: 686, y: 1062, w: 63, h: 26, group: 'g1062'},
            {type: 'y', x: 611, y: 1062, w: 63, h: 26, default: 'yes', group: 'g1062'},
            {type: 'y', x: 686, y: 1091, w: 63, h: 26, group: 'g1091'},
            {type: 'y', x: 611, y: 1091, w: 63, h: 26, default: 'yes', group: 'g1091'},
            {type: 'y', x: 686, y: 1119, w: 63, h: 26, group: 'g1119'},
            {type: 'y', x: 611, y: 1119, w: 63, h: 26, default: 'yes', group: 'g1119'},
            {type: 'y', x: 686, y: 1147, w: 63, h: 26, group: 'g1147'},
            {type: 'y', x: 611, y: 1147, w: 63, h: 26, default: 'yes', group: 'g1147'},
            {type: 'y', x: 686, y: 1175, w: 63, h: 26, group: 'g1175'},
            {type: 'y', x: 611, y: 1175, w: 63, h: 26, default: 'yes', group: 'g1175'},
            {type: 'y', x: 686, y: 1204, w: 63, h: 26, group: 'g1204'},
            {type: 'y', x: 611, y: 1204, w: 63, h: 26, default: 'yes', group: 'g1204'},
            {type: 'y', x: 686, y: 1232, w: 63, h: 26, group: 'g1232'},
            {type: 'y', x: 611, y: 1232, w: 63, h: 26, default: 'yes', group: 'g1232'},
            {type: 'ta', x: 137, y: 1282, w: 1071, h: 30},
            {type: 't', x: 677, y: 1317, w: 200, h: 25, default: props.user.name, readonly: true},
            {type: 'i', x: 467, y: 1305, w: 200, h: 52, default: props.user.signature, readonly: true},
        ]
    },
    {
        text: 'لوحة التوزيع',
        image: minipillar,
        fields: [
            {type: 't', x: 790, y: 265, w: 295, h: 25, default: props.dep, align: 'center'},
            {type: 't', x: 255, y: 265, w: 295, h: 25, default: props.div, align: 'center'},
            {type: 't', x: 843, y: 305, w: 235, h: 25, default: props.number, align: 'center'},
            {type: 't', x: 307, y: 305, w: 250, h: 25, default: props.district, align: 'center'},
            {type: 't', x: 862, y: 345, w: 235, h: 25, default: props.feeder, align: 'center'},
            {type: 't', x: 328, y: 345, w: 220, h: 25, default: props.contractor, align: 'center'},
            {type: 'y', x: 683, y: 435, w: 66, h: 35, group: 'g435'},
            {type: 'y', x: 612, y: 435, w: 66, h: 35, default: 'yes', group: 'g435'},
            {type: 'y', x: 683, y: 480, w: 66, h: 35, group: 'g480'},
            {type: 'y', x: 612, y: 480, w: 66, h: 35, default: 'yes', group: 'g480'},
            {type: 'y', x: 683, y: 525, w: 66, h: 35, group: 'g525'},
            {type: 'y', x: 612, y: 525, w: 66, h: 35, default: 'yes', group: 'g525'},
            {type: 'y', x: 683, y: 570, w: 66, h: 35, group: 'g570'},
            {type: 'y', x: 612, y: 570, w: 66, h: 35, default: 'yes', group: 'g570'},
            {type: 'y', x: 683, y: 612, w: 66, h: 35, group: 'g612'},
            {type: 'y', x: 612, y: 612, w: 66, h: 35, default: 'yes', group: 'g612'},
            {type: 'y', x: 683, y: 657, w: 66, h: 35, group: 'g657'},
            {type: 'y', x: 612, y: 657, w: 66, h: 35, default: 'yes', group: 'g657'},
            {type: 'y', x: 683, y: 702, w: 66, h: 35, group: 'g702'},
            {type: 'y', x: 612, y: 702, w: 66, h: 35, default: 'yes', group: 'g702'},
            {type: 'y', x: 683, y: 744, w: 66, h: 35, group: 'g744'},
            {type: 'y', x: 612, y: 744, w: 66, h: 35, default: 'yes', group: 'g744'},
            {type: 'y', x: 683, y: 789, w: 66, h: 35, group: 'g789'},
            {type: 'y', x: 612, y: 789, w: 66, h: 35, default: 'yes', group: 'g789'},
            {type: 'y', x: 683, y: 834, w: 66, h: 35, group: 'g834'},
            {type: 'y', x: 612, y: 834, w: 66, h: 35, default: 'yes', group: 'g834'},
            {type: 'y', x: 683, y: 876, w: 66, h: 35, group: 'g876'},
            {type: 'y', x: 612, y: 876, w: 66, h: 35, default: 'yes', group: 'g876'},
            {type: 'y', x: 683, y: 921, w: 66, h: 35, group: 'g921'},
            {type: 'y', x: 612, y: 921, w: 66, h: 35, default: 'yes', group: 'g921'},
            {type: 'y', x: 683, y: 966, w: 66, h: 35, group: 'g966'},
            {type: 'y', x: 612, y: 966, w: 66, h: 35, default: 'yes', group: 'g966'},
            {type: 'y', x: 683, y: 1008, w: 66, h: 35, group: 'g1008'},
            {type: 'y', x: 612, y: 1008, w: 66, h: 35, default: 'yes', group: 'g1008'},
            {type: 'ta', x: 315, y: 1095, w: 660, h: 75},
            {type: 't', x: 618, y: 1190, w: 300, h: 25, default: props.user.name, readonly: true},
            {type: 'i', x: 285, y: 1175, w: 200, h: 52, default: props.user.signature, readonly: true},
        ]
    },
    {
        text: 'صحيفة قياس للعدادات',
        image: measurementsSheetForMeters,
        fields: [
            {type: 't', x: 945, y: 200, w: 175, h: 30, default: props.dep, align: 'center'},
            {type: 't', x: 705, y: 200, w: 125, h: 30, default: props.div, align: 'center'},
            {type: 't', x: 420, y: 200, w: 165, h: 30, default: props.district, align: 'center'},
            {type: 't', x: 65, y: 205, w: 165, h: 30, default: props.number},
            {type: 't', x: 815, y: 296, w: 63, h: 30, align: 'center'},
            {type: 't', x: 328, y: 296, w: 72, h: 30, align: 'center'},
            {type: 't', x: 60 , y: 296, w: 63, h: 30, align: 'center'},
            {type: 't', x: 815, y: 338, w: 63, h: 30, align: 'center'},
            {type: 't', x: 328, y: 338, w: 72, h: 30, align: 'center'},
            {type: 't', x: 60 , y: 338, w: 63, h: 30, align: 'center'},
            {type: 't', x: 815, y: 393, w: 63, h: 30, align: 'center'},
            {type: 't', x: 328, y: 393, w: 72, h: 30, align: 'center'},
            {type: 't', x: 60 , y: 393, w: 63, h: 30, align: 'center'},
            {type: 't', x: 815, y: 447, w: 63, h: 30, align: 'center'},
            {type: 't', x: 328, y: 447, w: 72, h: 30, align: 'center'},
            {type: 't', x: 60 , y: 447, w: 63, h: 30, align: 'center'},
            {type: 't', x: 815, y: 505, w: 63, h: 30, align: 'center'},
            {type: 't', x: 328, y: 505, w: 72, h: 30, align: 'center'},
            {type: 't', x: 60 , y: 505, w: 63, h: 30, align: 'center'},
            {type: 't', x: 815, y: 563, w: 63, h: 30, align: 'center'},
            {type: 't', x: 328, y: 563, w: 72, h: 30, align: 'center'},
            {type: 't', x: 60 , y: 563, w: 63, h: 30, align: 'center'},
            {type: 't', x: 815, y: 623, w: 63, h: 30, align: 'center'},
            {type: 't', x: 328, y: 623, w: 72, h: 30, align: 'center'},
            {type: 't', x: 60 , y: 623, w: 63, h: 30, align: 'center'},
            {type: 't', x: 815, y: 681, w: 63, h: 30, align: 'center'},
            {type: 't', x: 328, y: 681, w: 72, h: 30, align: 'center'},
            {type: 't', x: 60 , y: 681, w: 63, h: 30, align: 'center'},
            {type: 't', x: 815, y: 726, w: 63, h: 30, align: 'center'},
            {type: 't', x: 328, y: 726, w: 72, h: 30, align: 'center'},
            {type: 't', x: 60 , y: 726, w: 63, h: 30, align: 'center'},
            {type: 't', x: 815, y: 771, w: 63, h: 30, align: 'center'},
            {type: 't', x: 328, y: 771, w: 72, h: 30, align: 'center'},
            {type: 't', x: 60 , y: 771, w: 63, h: 30, align: 'center'},
            {type: 't', x: 815, y: 814, w: 63, h: 30, align: 'center'},
            {type: 't', x: 328, y: 814, w: 72, h: 30, align: 'center'},
            {type: 't', x: 60 , y: 814, w: 63, h: 30, align: 'center'},
            {type: 't', x: 815, y: 851, w: 63, h: 30, align: 'center'},
            {type: 't', x: 328, y: 851, w: 72, h: 30, align: 'center'},
            {type: 't', x: 60 , y: 851, w: 63, h: 30, align: 'center'},
            {type: 't', x: 815, y: 896, w: 63, h: 30, align: 'center'},
            {type: 't', x: 328, y: 896, w: 72, h: 30, align: 'center'},
            {type: 't', x: 60 , y: 896, w: 63, h: 30, align: 'center'},
            {type: 't', x: 815, y: 934, w: 63, h: 30, align: 'center'},
            {type: 't', x: 328, y: 934, w: 72, h: 30, align: 'center'},
            {type: 't', x: 60 , y: 934, w: 63, h: 30, align: 'center'},
            {type: 't', x: 815, y: 963, w: 63, h: 30, align: 'center'},
            {type: 't', x: 328, y: 963, w: 72, h: 30, align: 'center'},
            {type: 't', x: 60 , y: 963, w: 63, h: 30, align: 'center'},
            {type: 't', x: 815, y: 992, w: 63, h: 30, align: 'center'},
            {type: 't', x: 328, y: 992, w: 72, h: 30, align: 'center'},
            {type: 't', x: 60 , y: 992, w: 63, h: 30, align: 'center'},
            {type: 't', x: 815, y: 1021, w: 63, h: 30, align: 'center'},
            {type: 't', x: 328, y: 1021, w: 72, h: 30, align: 'center'},
            {type: 't', x: 60 , y: 1021, w: 63, h: 30, align: 'center'},
            {type: 't', x: 815, y: 1051, w: 63, h: 30, align: 'center'},
            {type: 't', x: 328, y: 1051, w: 72, h: 30, align: 'center'},
            {type: 't', x: 60 , y: 1051, w: 63, h: 30, align: 'center'},
            {type: 't', x: 815, y: 1081, w: 63, h: 30, align: 'center'},
            {type: 't', x: 328, y: 1081, w: 72, h: 30, align: 'center'},
            {type: 't', x: 60 , y: 1081, w: 63, h: 30, align: 'center'},
            {type: 't', x: 815, y: 1111, w: 63, h: 30, align: 'center'},
            {type: 't', x: 328, y: 1111, w: 72, h: 30, align: 'center'},
            {type: 't', x: 60 , y: 1111, w: 63, h: 30, align: 'center'},
            {type: 't', x: 815, y: 1141, w: 63, h: 30, align: 'center'},
            {type: 't', x: 328, y: 1141, w: 72, h: 30, align: 'center'},
            {type: 't', x: 60 , y: 1141, w: 63, h: 30, align: 'center'},
            {type: 't', x: 815, y: 1184, w: 63, h: 30, align: 'center'},
            {type: 't', x: 328, y: 1184, w: 72, h: 30, align: 'center'},
            {type: 't', x: 60 , y: 1184, w: 63, h: 30, align: 'center'},
            {type: 't', x: 815, y: 1230, w: 63, h: 30, align: 'center'},
            {type: 't', x: 328, y: 1230, w: 72, h: 30, align: 'center'},
            {type: 't', x: 60 , y: 1230, w: 63, h: 30, align: 'center'},
            {type: 't', x: 815, y: 1260, w: 63, h: 30, align: 'center'},
            {type: 't', x: 328, y: 1260, w: 72, h: 30, align: 'center'},
            {type: 't', x: 60 , y: 1260, w: 63, h: 30, align: 'center'},
            {type: 't', x: 815, y: 1290, w: 63, h: 30, align: 'center'},
            {type: 't', x: 328, y: 1290, w: 72, h: 30, align: 'center'},
            {type: 't', x: 60 , y: 1290, w: 63, h: 30, align: 'center'},
            {type: 'ta', x: 240, y: 1320, w: 800, h: 42},
            {type: 't', x: 595, y: 1365, w: 200, h: 30, default: props.user.name, readonly: true},
            {type: 'i', x: 375, y: 1350, w: 200, h: 52, default: props.user.signature, readonly: true},
        ]
    },
    {
        text: 'نموذج تركيب عداد عادي / عداد محول تيار',
        image: lvMeterInstallation,
        fields: [
            {type: 't', x: 645, y: 400, w: 330, h: 25, default: props.dep},
            {type: 't', x: 197, y: 400, w: 330, h: 25, default: props.div},
            {type: 't', x: 713, y: 437, w: 417, h: 25, default: props.district},
            {type: 't', x: 720, y: 472, w: 410, h: 25, default: props.contractor},
            {type: 't', x: 240, y: 455, w: 285, h: 25, default: props.number, align: 'center'},
            {type: 'y', x: 638, y: 647, w: 63, h: 34, group: 'g647'},
            {type: 'y', x: 551, y: 647, w: 85, h: 34, default: 'yes', group: 'g647'},
            {type: 'y', x: 638, y: 719, w: 63, h: 34, group: 'g719'},
            {type: 'y', x: 551, y: 719, w: 85, h: 34, default: 'yes', group: 'g719'},
            {type: 'y', x: 638, y: 780, w: 63, h: 34, group: 'g780'},
            {type: 'y', x: 551, y: 780, w: 85, h: 34, default: 'yes', group: 'g780'},
            {type: 'y', x: 638, y: 854, w: 63, h: 34, group: 'g854'},
            {type: 'y', x: 551, y: 854, w: 85, h: 34, default: 'yes', group: 'g854'},
            {type: 'y', x: 638, y: 942, w: 63, h: 34, group: 'g942'},
            {type: 'y', x: 551, y: 942, w: 85, h: 34, default: 'yes', group: 'g942'},
            {type: 'y', x: 638, y: 1001, w: 63, h: 34, group: 'g1001'},
            {type: 'y', x: 551, y: 1001, w: 85, h: 34, default: 'na', group: 'g1001'},
            {type: 'y', x: 638, y: 1051, w: 63, h: 34, group: 'g1051'},
            {type: 'y', x: 551, y: 1051, w: 85, h: 34, default: 'na', group: 'g1051'},
            {type: 'y', x: 638, y: 1099, w: 63, h: 34, group: 'g1099'},
            {type: 'y', x: 551, y: 1099, w: 85, h: 34, default: 'yes', group: 'g1099'},
            {type: 'y', x: 638, y: 1148, w: 63, h: 34, group: 'g1148'},
            {type: 'y', x: 551, y: 1148, w: 85, h: 34, default: 'yes', group: 'g1148'},
            {type: 't', x: 690, y: 1277, w: 300, h: 25, default: props.user.name, readonly: true},
            {type: 'i', x: 311, y: 1254, w: 200, h: 52, default: props.user.signature, readonly: true},
        ]
    },
    {
        text: 'إجراء رقم (١٩٠)',
        image: procedure190,
        fields: [
            {type: 't', x: 633, y: 338, w: 390, h: 25, default: props.number},
            {type: 't', x: 96, y: 338, w: 330, h: 25, default: props.district},
            {type: 't', x: 633, y: 381, w: 390, h: 25, default: props.contractor},
            {type: 't', x: 96, y: 381, w: 330, h: 25, default: props.feeder},
            {type: 'y', x: 496, y: 492, w: 97, h: 40, default: 'yes', group: 'g492'},
            {type: 'y', x: 400, y: 492, w: 91, h: 40, group: 'g492'},
            {type: 't', x: 98, y: 492, w: 298, h: 40},
            {type: 'y', x: 496, y: 547, w: 97, h: 40, default: 'yes', group: 'g547'},
            {type: 'y', x: 400, y: 547, w: 91, h: 40, group: 'g547'},
            {type: 't', x: 98, y: 547, w: 298, h: 40},
            {type: 'y', x: 496, y: 600, w: 97, h: 40, default: 'yes', group: 'g600'},
            {type: 'y', x: 400, y: 600, w: 91, h: 40, group: 'g600'},
            {type: 't', x: 98, y: 600, w: 298, h: 40},
            {type: 'y', x: 496, y: 655, w: 97, h: 40, default: 'na', group: 'g655'},
            {type: 'y', x: 400, y: 655, w: 91, h: 40, group: 'g655'},
            {type: 't', x: 98, y: 655, w: 298, h: 40},
            {type: 'y', x: 496, y: 708, w: 97, h: 40, default: 'yes', group: 'g708'},
            {type: 'y', x: 400, y: 708, w: 91, h: 40, group: 'g708'},
            {type: 't', x: 98, y: 708, w: 298, h: 40},
            {type: 'y', x: 496, y: 763, w: 97, h: 40, default: 'yes', group: 'g763'},
            {type: 'y', x: 400, y: 763, w: 91, h: 40, group: 'g763'},
            {type: 't', x: 98, y: 763, w: 298, h: 40},
            {type: 'y', x: 496, y: 835, w: 97, h: 40, default: 'yes', group: 'g835'},
            {type: 'y', x: 400, y: 835, w: 91, h: 40, group: 'g835'},
            {type: 't', x: 98, y: 835, w: 298, h: 40},
            {type: 'y', x: 496, y: 921, w: 97, h: 40, default: 'yes', group: 'g921'},
            {type: 'y', x: 400, y: 921, w: 91, h: 40, group: 'g921'},
            {type: 't', x: 98, y: 921, w: 298, h: 40},
            {type: 'y', x: 496, y: 1009, w: 97, h: 40, default: 'yes', group: 'g1009'},
            {type: 'y', x: 400, y: 1009, w: 91, h: 40, group: 'g1009'},
            {type: 't', x: 98, y: 1009, w: 298, h: 40},
            {type: 't', x: 772, y: 1242, w: 171, h: 47, default: props.supervisor.name, readonly: true},
            {type: 'i', x: 482, y: 1240, w: 200, h: 52, default: props.supervisor.signature, readonly: true},
            {type: 't', x: 75, y: 1242, w: 200, h: 47, default: props.now_date, readonly: true},
            {type: 't', x: 772, y: 1293, w: 171, h: 47, default: props.user.name, readonly: true},
            {type: 'i', x: 482, y: 1293, w: 200, h: 52, default: props.user.signature, readonly: true},
            {type: 't', x: 75, y: 1293, w: 200, h: 47, default: props.now_date, readonly: true},
        ]
    },
    {
        text: 'نموذج القياس',
        image: measurementSheet,
        fields: [
            {type: 't', x: 1170, y: 140, w: 310, h: 20, default: props.dep, fontSize: 10},
            {type: 't', x: 827, y: 140, w: 210, h: 20, default: props.number, fontSize: 10},
            {type: 't', x: 1170, y: 168, w: 310, h: 20, default: props.div, fontSize: 10},
            {type: 't', x: 827, y: 168, w: 210, h: 20, default: props.feeder, fontSize: 10},
            {type: 't', x: 1170, y: 197, w: 310, h: 20, default: props.contractor, fontSize: 10},
            {type: 't', x: 827, y: 197, w: 210, h: 20, default: props.district, fontSize: 10},
            {type: 't', x: 1550, y: 504, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1486, y: 504, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1423, y: 504, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1359, y: 504, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1295, y: 504, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1231, y: 504, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1168, y: 504, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1104, y: 504, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1040, y: 504, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 953, y: 504, w: 83, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 889, y: 504, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 825, y: 504, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 765, y: 504, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 698, y: 504, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 634, y: 504, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 570, y: 504, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 506, y: 504, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 443, y: 504, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 379, y: 504, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 315, y: 504, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1550, y: 526, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1486, y: 526, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1423, y: 526, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1359, y: 526, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1295, y: 526, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1231, y: 526, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1168, y: 526, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1104, y: 526, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1040, y: 526, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 953, y: 526, w: 83, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 889, y: 526, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 825, y: 526, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 765, y: 526, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 698, y: 526, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 634, y: 526, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 570, y: 526, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 506, y: 526, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 443, y: 526, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 379, y: 526, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 315, y: 526, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1550, y: 549, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1486, y: 549, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1423, y: 549, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1359, y: 549, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1295, y: 549, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1231, y: 549, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1168, y: 549, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1104, y: 549, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1040, y: 549, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 953, y: 549, w: 83, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 889, y: 549, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 825, y: 549, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 765, y: 549, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 698, y: 549, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 634, y: 549, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 570, y: 549, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 506, y: 549, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 443, y: 549, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 379, y: 549, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 315, y: 549, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1550, y: 572, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1486, y: 572, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1423, y: 572, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1359, y: 572, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1295, y: 572, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1231, y: 572, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1168, y: 572, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1104, y: 572, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1040, y: 572, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 953, y: 572, w: 83, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 889, y: 572, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 825, y: 572, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 765, y: 572, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 698, y: 572, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 634, y: 572, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 570, y: 572, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 506, y: 572, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 443, y: 572, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 379, y: 572, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 315, y: 572, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1550, y: 595, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1486, y: 595, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1423, y: 595, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1359, y: 595, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1295, y: 595, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1231, y: 595, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1168, y: 595, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1104, y: 595, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1040, y: 595, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 953, y: 595, w: 83, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 889, y: 595, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 825, y: 595, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 765, y: 595, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 698, y: 595, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 634, y: 595, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 570, y: 595, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 506, y: 595, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 443, y: 595, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 379, y: 595, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 315, y: 595, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1550, y: 619, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1486, y: 619, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1423, y: 619, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1359, y: 619, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1295, y: 619, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1231, y: 619, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1168, y: 619, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1104, y: 619, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1040, y: 619, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 953, y: 619, w: 83, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 889, y: 619, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 825, y: 619, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 765, y: 619, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 698, y: 619, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 634, y: 619, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 570, y: 619, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 506, y: 619, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 443, y: 619, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 379, y: 619, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 315, y: 619, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1550, y: 642, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1486, y: 642, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1423, y: 642, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1359, y: 642, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1295, y: 642, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1231, y: 642, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1168, y: 642, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1104, y: 642, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1040, y: 642, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 953, y: 642, w: 83, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 889, y: 642, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 825, y: 642, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 765, y: 642, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 698, y: 642, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 634, y: 642, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 570, y: 642, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 506, y: 642, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 443, y: 642, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 379, y: 642, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 315, y: 642, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1550, y: 665, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1486, y: 665, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1423, y: 665, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1359, y: 665, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1295, y: 665, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1231, y: 665, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1168, y: 665, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1104, y: 665, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1040, y: 665, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 953, y: 665, w: 83, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 889, y: 665, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 825, y: 665, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 765, y: 665, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 698, y: 665, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 634, y: 665, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 570, y: 665, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 506, y: 665, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 443, y: 665, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 379, y: 665, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 315, y: 665, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1550, y: 687, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1486, y: 687, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1423, y: 687, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1359, y: 687, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1295, y: 687, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1231, y: 687, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1168, y: 687, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1104, y: 687, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1040, y: 687, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 953, y: 687, w: 83, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 889, y: 687, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 825, y: 687, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 765, y: 687, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 698, y: 687, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 634, y: 687, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 570, y: 687, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 506, y: 687, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 443, y: 687, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 379, y: 687, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 315, y: 687, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1550, y: 710, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1486, y: 710, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1423, y: 710, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1359, y: 710, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1295, y: 710, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1231, y: 710, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1168, y: 710, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1104, y: 710, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 1040, y: 710, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 953, y: 710, w: 83, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 889, y: 710, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 825, y: 710, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 765, y: 710, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 698, y: 710, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 634, y: 710, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 570, y: 710, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 506, y: 710, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 443, y: 710, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 379, y: 710, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 't', x: 315, y: 710, w: 60, h: 20, fontSize: 8, drawSize: 4},
            {type: 'ta', x: 44, y: 337, w: 267, h: 391, fontSize: 10},
            {type: 't', x: 1210, y: 770, w: 230, h: 20, default: props.supervisor.name, readonly: true, fontSize: 10},
            {type: 'i', x: 1000, y: 750, w: 200, h: 52, default: props.supervisor.signature, readonly: true, fontSize: 10},
            {type: 't', x: 275, y: 770, w: 230, h: 20, default: props.user.name, readonly: true, fontSize: 10},
            {type: 'i', x: 65, y: 750, w: 200, h: 52, default: props.user.signature, readonly: true, fontSize: 10},
        ]
    },
    {
        text: 'فحص محطة التوزيع والمعدات الكهربائية',
        image: substationAndElectricalEquipmentInspection,
        fields: [
            {type: 't', x: 985, y: 266, w: 130, h: 25, default: props.dep, align: 'center'},
            {type: 't', x: 658, y: 266, w: 145, h: 25, default: props.div, align: 'center'},
            {type: 't', x: 457, y: 266, w: 66, h: 25, default: props.district, align: 'center'},
            {type: 't', x: 118, y: 270, w: 161, h: 25, default: props.feeder},
            {type: 'y', x: 696, y: 337, w: 72, h: 25, group: 'g337'},
            {type: 'y', x: 595, y: 337, w: 97, h: 25, group: 'g337'},
            {type: 'y', x: 696, y: 365, w: 72, h: 25, group: 'g365'},
            {type: 'y', x: 595, y: 365, w: 97, h: 25, group: 'g365'},
            {type: 'y', x: 696, y: 393, w: 72, h: 25, group: 'g393'},
            {type: 'y', x: 595, y: 393, w: 97, h: 25, group: 'g393'},
            {type: 'y', x: 696, y: 421, w: 72, h: 25, group: 'g421'},
            {type: 'y', x: 595, y: 421, w: 97, h: 25, group: 'g421'},
            {type: 'y', x: 696, y: 449, w: 72, h: 25, group: 'g449'},
            {type: 'y', x: 595, y: 449, w: 97, h: 25, group: 'g449'},
            {type: 'y', x: 696, y: 482, w: 72, h: 25, group: 'g482'},
            {type: 'y', x: 595, y: 482, w: 97, h: 25, group: 'g482'},
            {type: 'y', x: 696, y: 515, w: 72, h: 25, group: 'g515'},
            {type: 'y', x: 595, y: 515, w: 97, h: 25, group: 'g515'},
            {type: 'y', x: 696, y: 547, w: 72, h: 25, group: 'g547'},
            {type: 'y', x: 595, y: 547, w: 97, h: 25, group: 'g547'},
            {type: 'y', x: 696, y: 581, w: 72, h: 25, group: 'g581'},
            {type: 'y', x: 595, y: 581, w: 97, h: 25, group: 'g581'},
            {type: 'y', x: 696, y: 609, w: 72, h: 25, group: 'g609'},
            {type: 'y', x: 595, y: 609, w: 97, h: 25, group: 'g609'},
            {type: 'y', x: 696, y: 646, w: 72, h: 25, group: 'g646'},
            {type: 'y', x: 595, y: 646, w: 97, h: 25, group: 'g646'},
            {type: 'y', x: 696, y: 683, w: 72, h: 25, group: 'g683'},
            {type: 'y', x: 595, y: 683, w: 97, h: 25, group: 'g683'},
            {type: 'y', x: 696, y: 711, w: 72, h: 25, group: 'g711'},
            {type: 'y', x: 595, y: 711, w: 97, h: 25, group: 'g711'},
            {type: 'y', x: 696, y: 739, w: 72, h: 25, group: 'g739'},
            {type: 'y', x: 595, y: 739, w: 97, h: 25, group: 'g739'},
            {type: 'y', x: 696, y: 768, w: 72, h: 25, group: 'g768'},
            {type: 'y', x: 595, y: 768, w: 97, h: 25, group: 'g768'},
            {type: 'y', x: 696, y: 796, w: 72, h: 25, group: 'g796'},
            {type: 'y', x: 595, y: 796, w: 97, h: 25, group: 'g796'},
            {type: 'y', x: 696, y: 823, w: 72, h: 25, group: 'g823'},
            {type: 'y', x: 595, y: 823, w: 97, h: 25, group: 'g823'},
            {type: 'y', x: 696, y: 851, w: 72, h: 25, group: 'g851'},
            {type: 'y', x: 595, y: 851, w: 97, h: 25, group: 'g851'},
            {type: 'y', x: 696, y: 880, w: 72, h: 25, group: 'g880'},
            {type: 'y', x: 595, y: 880, w: 97, h: 25, group: 'g880'},
            {type: 'y', x: 696, y: 908, w: 72, h: 25, group: 'g908'},
            {type: 'y', x: 595, y: 908, w: 97, h: 25, group: 'g908'},
            {type: 'y', x: 696, y: 936, w: 72, h: 25, group: 'g936'},
            {type: 'y', x: 595, y: 936, w: 97, h: 25, group: 'g936'},
            {type: 'y', x: 696, y: 964, w: 72, h: 25, group: 'g964'},
            {type: 'y', x: 595, y: 964, w: 97, h: 25, group: 'g964'},
            {type: 'y', x: 696, y: 997, w: 72, h: 25, group: 'g997'},
            {type: 'y', x: 595, y: 997, w: 97, h: 25, group: 'g997'},
            {type: 'y', x: 696, y: 1030, w: 72, h: 25, group: 'g1030'},
            {type: 'y', x: 595, y: 1030, w: 97, h: 25, group: 'g1030'},
            {type: 'y', x: 696, y: 1058, w: 72, h: 25, group: 'g1058'},
            {type: 'y', x: 595, y: 1058, w: 97, h: 25, group: 'g1058'},
            {type: 'y', x: 696, y: 1087, w: 72, h: 25, group: 'g1087'},
            {type: 'y', x: 595, y: 1087, w: 97, h: 25, group: 'g1087'},
            {type: 'y', x: 696, y: 1115, w: 72, h: 25, group: 'g1115'},
            {type: 'y', x: 595, y: 1115, w: 97, h: 25, group: 'g1115'},
            {type: 'y', x: 696, y: 1143, w: 72, h: 25, group: 'g1143'},
            {type: 'y', x: 595, y: 1143, w: 97, h: 25, group: 'g1143'},
            {type: 'y', x: 696, y: 1170, w: 72, h: 25, group: 'g1170'},
            {type: 'y', x: 595, y: 1170, w: 97, h: 25, group: 'g1170'},
            {type: 'y', x: 696, y: 1199, w: 72, h: 25, group: 'g1199'},
            {type: 'y', x: 595, y: 1199, w: 97, h: 25, group: 'g1199'},
            {type: 'y', x: 696, y: 1235, w: 72, h: 25, group: 'g1235'},
            {type: 'y', x: 595, y: 1235, w: 97, h: 25, group: 'g1235'},
            {type: 'y', x: 696, y: 1273, w: 72, h: 25, group: 'g1273'},
            {type: 'y', x: 595, y: 1273, w: 97, h: 25, group: 'g1273'},
            {type: 'y', x: 696, y: 1301, w: 72, h: 25, group: 'g1301'},
            {type: 'y', x: 595, y: 1301, w: 97, h: 25, group: 'g1301'},
            {type: 'y', x: 696, y: 1329, w: 72, h: 25, group: 'g1329'},
            {type: 'y', x: 595, y: 1329, w: 97, h: 25, group: 'g1329'},
            {type: 'y', x: 696, y: 1358, w: 72, h: 25, group: 'g1358'},
            {type: 'y', x: 595, y: 1358, w: 97, h: 25, group: 'g1358'},
            {type: 'y', x: 696, y: 1386, w: 72, h: 25, group: 'g1386'},
            {type: 'y', x: 595, y: 1386, w: 97, h: 25, group: 'g1386'},
            {type: 'ta', x: 274, y: 1419, w: 800, h: 25},
            {type: 't', x: 679, y: 1451, w: 200, h: 25, default: props.user.name, readonly: true},
            {type: 'i', x: 468, y: 1440, w: 200, h: 52, default: props.user.signature, readonly:  true},
        ]
    },
    {
        text: 'تأريض المحطات',
        image: substationEarthing,
        fields: [
            {type: 't', x: 710, y: 285, w: 336, h: 25, default: props.dep},
            {type: 't', x: 134, y: 285, w: 460, h: 25, default: props.div},
            {type: 't', x: 817, y: 334, w: 336, h: 25, default: props.district},
            {type: 't', x: 300, y: 334, w: 294, h: 25, default: props.number},
            {type: 't', x: 836, y: 379, w: 305, h: 25, default: props.contractor},
            {type: 't', x: 131, y: 379, w: 480, h: 25, default: props.feeder},
            {type: 'y', x: 708, y: 503, w: 71, h: 34, group: 'g503'},
            {type: 'y', x: 623, y: 503, w: 82, h: 34, default: 'yes', group: 'g503'},
            {type: 'y', x: 708, y: 551, w: 71, h: 34, group: 'g551'},
            {type: 'y', x: 623, y: 551, w: 82, h: 34, default: 'yes', group: 'g551'},
            {type: 'y', x: 708, y: 599, w: 71, h: 34, group: 'g599'},
            {type: 'y', x: 623, y: 599, w: 82, h: 34, default: 'yes', group: 'g599'},
            {type: 'y', x: 708, y: 662, w: 71, h: 34, group: 'g662'},
            {type: 'y', x: 623, y: 662, w: 82, h: 34, default: 'yes', group: 'g662'},
            {type: 'y', x: 708, y: 742, w: 71, h: 34, group: 'g742'},
            {type: 'y', x: 623, y: 742, w: 82, h: 34, default: 'yes', group: 'g742'},
            {type: 'y', x: 708, y: 823, w: 71, h: 34, group: 'g823'},
            {type: 'y', x: 623, y: 823, w: 82, h: 34, default: 'yes', group: 'g823'},
            {type: 'y', x: 708, y: 883, w: 71, h: 34, group: 'g883'},
            {type: 'y', x: 623, y: 883, w: 82, h: 34, default: 'yes', group: 'g883'},
            {type: 'ta', x: 145, y: 1115, w: 1057, h: 189},
            {type: 't', x: 624, y: 1313, w: 320, h: 25, default: props.user.name, readonly: true},
            {type: 'i', x: 300, y: 1300, w: 200, h: 52, default: props.user.signature, readonly: true},
        ]
    },
    {
        text: 'قواعد المحطات',
        image: substationFoundation,
        fields: [
            {type: 't', x: 766, y: 300, w: 220, h: 25, default: props.dep},
            {type: 't', x: 300, y: 300, w: 320, h: 25, default: props.div},
            {type: 't', x: 808, y: 338, w: 220, h: 25, default: props.district},
            {type: 't', x: 350, y: 338, w: 210, h: 25, default: props.number},
            {type: 't', x: 826, y: 375, w: 200, h: 25, default: props.contractor},
            {type: 't', x: 364, y: 375, w: 210, h: 25, default: props.feeder},
            {type: 'y', x: 682, y: 494, w: 76, h: 41, default: 'yes', group: 'g494'},
            {type: 'y', x: 617, y: 494, w: 62, h: 41, group: 'g494'},
            {type: 'y', x: 682, y: 617, w: 76, h: 41, default: 'yes', group: 'g617'},
            {type: 'y', x: 617, y: 617, w: 62, h: 41, group: 'g617'},
            {type: 'y', x: 682, y: 669, w: 76, h: 41, default: 'yes', group: 'g669'},
            {type: 'y', x: 617, y: 669, w: 62, h: 41, group: 'g669'},
            {type: 'y', x: 682, y: 734, w: 76, h: 41, default: 'yes', group: 'g734'},
            {type: 'y', x: 617, y: 734, w: 62, h: 41, group: 'g734'},
            {type: 'y', x: 682, y: 807, w: 76, h: 41, default: 'yes', group: 'g807'},
            {type: 'y', x: 617, y: 807, w: 62, h: 41, group: 'g807'},
            {type: 'y', x: 682, y: 870, w: 76, h: 41, default: 'yes', group: 'g870'},
            {type: 'y', x: 617, y: 870, w: 62, h: 41, group: 'g870'},
            {type: 'y', x: 682, y: 931, w: 76, h: 41, group: 'g931'},
            {type: 'y', x: 617, y: 931, w: 62, h: 41, default: 'yes', group: 'g931'},
            {type: 'ta', x: 165, y: 1222, w: 915, h: 82},
            {type: 't', x: 600, y: 1312, w: 266, h: 25, default: props.user.name, readonly: true},
            {type: 'i', x: 281, y: 1299, w: 200, h: 52, default: props.user.signature, readonly: true},
        ]
    },
    {
        text: 'نموذج فحص الأعمال الهوائية',
        image: listOHInspection,
        fields: [
            {type: 't', x: 980, y: 215, w: 120, h: 30, align: 'center', default: props.dep},
            {type: 't', x: 128, y: 215, w: 185, h: 30, align: 'center', default: props.div},
            {type: 't', x: 925, y: 305, w: 275, h: 30, align: 'center', default: props.contractor},
            {type: 't', x: 375, y: 305, w: 540, h: 30, align: 'center', default: props.number},
            {type: 't', x: 80, y: 305, w: 290, h: 30, align: 'center', default: props.district},
            {type: 'y', x: 980, y: 465, w: 55, h: 30, group: 'g465'},
            {type: 'y', x: 920, y: 465, w: 55, h: 30, group: 'g465'},
            {type: 'y', x: 980, y: 513, w: 55, h: 30, group: 'g513'},
            {type: 'y', x: 920, y: 513, w: 55, h: 30, group: 'g513'},
            {type: 'ta', x: 925, y: 580, w: 280, h: 160},
            {type: 'y', x: 714, y: 465, w: 71, h: 30, group: 'g465s'},
            {type: 'y', x: 655, y: 465, w: 56, h: 30, group: 'g465s'},
            {type: 'y', x: 714, y: 513, w: 71, h: 30, group: 'g513s'},
            {type: 'y', x: 655, y: 513, w: 56, h: 30, group: 'g513s'},
            {type: 'y', x: 714, y: 563, w: 71, h: 30, group: 'g563s'},
            {type: 'y', x: 655, y: 563, w: 56, h: 30, group: 'g563s'},
            {type: 'y', x: 714, y: 611, w: 71, h: 30, group: 'g611s'},
            {type: 'y', x: 655, y: 611, w: 56, h: 30, group: 'g611s'},
            {type: 'y', x: 714, y: 660, w: 71, h: 30, group: 'g660s'},
            {type: 'y', x: 655, y: 660, w: 56, h: 30, group: 'g660s'},
            {type: 'y', x: 714, y: 705, w: 71, h: 30, group: 'g705s'},
            {type: 'y', x: 655, y: 705, w: 56, h: 30, group: 'g705s'},
            {type: 'y', x: 448, y: 465, w: 56, h: 30, group: 'g465t'},
            {type: 'y', x: 375, y: 465, w: 71, h: 30, group: 'g465t'},
            {type: 'y', x: 448, y: 513, w: 56, h: 30, group: 'g513t'},
            {type: 'y', x: 375, y: 513, w: 71, h: 30, group: 'g513t'},
            {type: 'y', x: 448, y: 563, w: 56, h: 30, group: 'g563t'},
            {type: 'y', x: 375, y: 563, w: 71, h: 30, group: 'g563t'},
            {type: 'y', x: 448, y: 611, w: 56, h: 30, group: 'g611t'},
            {type: 'y', x: 375, y: 611, w: 71, h: 30, group: 'g611t'},
            {type: 'y', x: 448, y: 660, w: 56, h: 30, group: 'g660t'},
            {type: 'y', x: 375, y: 660, w: 71, h: 30, group: 'g660t'},
            {type: 'ta', x: 375, y: 700, w: 190, h: 42},
            {type: 'y', x: 153, y: 465, w: 56, h: 30, group: 'g465f'},
            {type: 'y', x: 79, y: 465, w: 71, h: 30, group: 'g465f'},
            {type: 'y', x: 153, y: 513, w: 56, h: 30, group: 'g513f'},
            {type: 'y', x: 79, y: 513, w: 71, h: 30, group: 'g513f'},
            {type: 'y', x: 153, y: 563, w: 56, h: 30, group: 'g563f'},
            {type: 'y', x: 79, y: 563, w: 71, h: 30, group: 'g563f'},
            {type: 'y', x: 153, y: 611, w: 56, h: 30, group: 'g611f'},
            {type: 'y', x: 79, y: 611, w: 71, h: 30, group: 'g611f'},
            {type: 'y', x: 153, y: 660, w: 56, h: 30, group: 'g660f'},
            {type: 'y', x: 79, y: 660, w: 71, h: 30, group: 'g660f'},
            {type: 'ta', x: 79, y: 700, w: 216, h: 42},
            {type: 'y', x: 980, y: 875, w: 55, h: 30, group: 'g875i'},
            {type: 'y', x: 920, y: 875, w: 55, h: 30, group: 'g875i'},
            {type: 'y', x: 980, y: 933, w: 55, h: 30, group: 'g933i'},
            {type: 'y', x: 920, y: 933, w: 55, h: 30, group: 'g933i'},
            {type: 'y', x: 980, y: 1009, w: 55, h: 30, group: 'g1009i'},
            {type: 'y', x: 920, y: 1009, w: 55, h: 30, group: 'g1009i'},
            {type: 'y', x: 980, y: 1066, w: 55, h: 30, group: 'g1066i'},
            {type: 'y', x: 920, y: 1066, w: 55, h: 30, group: 'g1066i'},
            {type: 'y', x: 980, y: 1115, w: 55, h: 30, group: 'g1115i'},
            {type: 'y', x: 920, y: 1115, w: 55, h: 30, group: 'g1115i'},
            {type: 'ta', x: 922, y: 1184, w: 282, h: 50},
            {type: 'y', x: 715, y: 875, w: 70, h: 30, group: 'g875x'},
            {type: 'y', x: 655, y: 875, w: 55, h: 30, group: 'g875x'},
            {type: 'ta', x: 657, y: 939, w: 259, h: 297},
            {type: 'y', x: 448, y: 875, w: 56, h: 30, group: 'g875v'},
            {type: 'y', x: 375, y: 875, w: 71, h: 30, group: 'g875v'},
            {type: 'y', x: 448, y: 932, w: 56, h: 30, group: 'g932v'},
            {type: 'y', x: 375, y: 932, w: 71, h: 30, group: 'g932v'},
            {type: 'y', x: 448, y: 1008, w: 56, h: 30, group: 'g1008v'},
            {type: 'y', x: 375, y: 1008, w: 71, h: 30, group: 'g1008v'},
            {type: 'y', x: 448, y: 1066, w: 56, h: 30, group: 'g1066v'},
            {type: 'y', x: 375, y: 1066, w: 71, h: 30, group: 'g1066v'},
            {type: 'ta', x: 375, y: 1133, w: 278, h: 103},
            {type: 'y', x: 153, y: 875, w: 56, h: 30, group: 'g875g'},
            {type: 'y', x: 79, y: 875, w: 71, h: 30, group: 'g875g'},
            {type: 'y', x: 153, y: 932, w: 56, h: 30, group: 'g932g'},
            {type: 'y', x: 79, y: 932, w: 71, h: 30, group: 'g932g'},
            {type: 'y', x: 153, y: 1009, w: 56, h: 30, group: 'g1009g'},
            {type: 'y', x: 79, y: 1009, w: 71, h: 30, group: 'g1009g'},
            {type: 'y', x: 153, y: 1066, w: 56, h: 30, group: 'g1066g'},
            {type: 'y', x: 79, y: 1066, w: 71, h: 30, group: 'g1066g'},
            {type: 'y', x: 153, y: 1115, w: 56, h: 30, group: 'g1115g'},
            {type: 'y', x: 79, y: 1115, w: 71, h: 30, group: 'g1115g'},
            {type: 'y', x: 153, y: 1160, w: 56, h: 30, group: 'g1160g'},
            {type: 'y', x: 79, y: 1160, w: 71, h: 30, group: 'g1160g'},
            {type: 'y', x: 153, y: 1200, w: 56, h: 30, group: 'g1200g'},
            {type: 'y', x: 79, y: 1200, w: 71, h: 30, group: 'g1200g'},
            {type: 'y', x: 713, y: 1313, w: 71, h: 30, group: 'g1313n'},
            {type: 'y', x: 654, y: 1313, w: 58, h: 30, group: 'g1313n'},
            {type: 'y', x: 713, y: 1343, w: 71, h: 30, group: 'g1343n'},
            {type: 'y', x: 654, y: 1343, w: 58, h: 30, group: 'g1343n'},
            {type: 'y', x: 713, y: 1373, w: 71, h: 30, group: 'g1373n'},
            {type: 'y', x: 654, y: 1373, w: 58, h: 30, group: 'g1373n'},
            {type: 'y', x: 713, y: 1402, w: 71, h: 30, group: 'g1402n'},
            {type: 'y', x: 654, y: 1402, w: 58, h: 30, group: 'g1402n'},
            {type: 'y', x: 713, y: 1432, w: 71, h: 30, group: 'g1432n'},
            {type: 'y', x: 654, y: 1432, w: 58, h: 30, group: 'g1432n'},
            {type: 't', x: 633, y: 1465, w: 200, h: 30, default: props.user.name, readonly: true},
            {type: 'i', x: 420, y: 1450, w: 200, h: 52, default: props.user.signature, readonly: true},
        ]
    },
    {
        text: 'نموذج فحص تفصيلي للخطوط الهوائية (المنفذة)',
        image: detailsOfOverheadLines,
        fields: [
            {type: 't', x: 900, y: 215, w: 200, h: 45, align: 'center', default: props.dep},
            {type: 't', x: 145, y: 215, w: 240, h: 45, align: 'center', default: props.div},
            {type: 't', x: 1035, y: 260, w: 72, h: 30, align: 'center', default: props.contractor},
            {type: 't', x: 545, y: 260, w: 150, h: 30, align: 'center', default: props.number},
            {type: 't', x: 270, y: 260, w: 85, h: 30, align: 'center', default: props.district},
            {type: 'y', x: 765, y: 375, w: 45, h: 30, group: 'g375'},
            {type: 'y', x: 721, y: 375, w: 45, h: 30, group: 'g375'},
            {type: 't', x: 80,  y: 375, w: 363, h: 30},
            {type: 'y', x: 765, y: 405, w: 45, h: 30, group: 'g405'},
            {type: 'y', x: 721, y: 405, w: 45, h: 30, group: 'g405'},
            {type: 't', x: 80,  y: 405, w: 363, h: 30},
            {type: 'y', x: 765, y: 435, w: 45, h: 30, group: 'g435'},
            {type: 'y', x: 721, y: 435, w: 45, h: 30, group: 'g435'},
            {type: 't', x: 80,  y: 435, w: 363, h: 30},
            {type: 'y', x: 765, y: 465, w: 45, h: 30, group: 'g465'},
            {type: 'y', x: 721, y: 465, w: 45, h: 30, group: 'g465'},
            {type: 't', x: 80,  y: 465, w: 363, h: 30},
            {type: 'y', x: 765, y: 495, w: 45, h: 30, group: 'g495'},
            {type: 'y', x: 721, y: 495, w: 45, h: 30, group: 'g495'},
            {type: 't', x: 80,  y: 495, w: 363, h: 30},
            {type: 'y', x: 765, y: 525, w: 45, h: 30, group: 'g525'},
            {type: 'y', x: 721, y: 525, w: 45, h: 30, group: 'g525'},
            {type: 't', x: 80,  y: 525, w: 363, h: 30},
            {type: 'y', x: 765, y: 555, w: 45, h: 30, group: 'g555'},
            {type: 'y', x: 721, y: 555, w: 45, h: 30, group: 'g555'},
            {type: 't', x: 80,  y: 555, w: 363, h: 30},
            {type: 'y', x: 765, y: 585, w: 45, h: 30, group: 'g585'},
            {type: 'y', x: 721, y: 585, w: 45, h: 30, group: 'g585'},
            {type: 't', x: 80,  y: 585, w: 363, h: 30},
            {type: 'y', x: 765, y: 615, w: 45, h: 30, group: 'g615'},
            {type: 'y', x: 721, y: 615, w: 45, h: 30, group: 'g615'},
            {type: 't', x: 80,  y: 615, w: 363, h: 30},
            {type: 'y', x: 765, y: 654, w: 45, h: 30, group: 'g654'},
            {type: 'y', x: 721, y: 654, w: 45, h: 30, group: 'g654'},
            {type: 't', x: 80,  y: 654, w: 363, h: 30},
            {type: 'y', x: 765, y: 733, w: 45, h: 30, group: 'g733'},
            {type: 'y', x: 721, y: 733, w: 45, h: 30, group: 'g733'},
            {type: 't', x: 80,  y: 733, w: 363, h: 30},
            {type: 'y', x: 765, y: 770, w: 45, h: 30, group: 'g770'},
            {type: 'y', x: 721, y: 770, w: 45, h: 30, group: 'g770'},
            {type: 't', x: 80,  y: 770, w: 363, h: 30},
            {type: 'y', x: 765, y: 811, w: 45, h: 30, group: 'g811'},
            {type: 'y', x: 721, y: 811, w: 45, h: 30, group: 'g811'},
            {type: 't', x: 80,  y: 811, w: 363, h: 30},
            {type: 'y', x: 765, y: 850, w: 45, h: 30, group: 'g850'},
            {type: 'y', x: 721, y: 850, w: 45, h: 30, group: 'g850'},
            {type: 't', x: 80,  y: 850, w: 363, h: 30},
            {type: 'y', x: 765, y: 880, w: 45, h: 30, group: 'g880'},
            {type: 'y', x: 721, y: 880, w: 45, h: 30, group: 'g880'},
            {type: 't', x: 80,  y: 880, w: 363, h: 30},
            {type: 'y', x: 765, y: 940, w: 45, h: 30, group: 'g940'},
            {type: 'y', x: 721, y: 940, w: 45, h: 30, group: 'g940'},
            {type: 't', x: 80,  y: 940, w: 363, h: 30},
            {type: 'y', x: 765, y: 970, w: 45, h: 30, group: 'g970'},
            {type: 'y', x: 721, y: 970, w: 45, h: 30, group: 'g970'},
            {type: 't', x: 80,  y: 970, w: 363, h: 30},
            {type: 'y', x: 765, y: 1009, w: 45, h: 30, group: 'g1009'},
            {type: 'y', x: 721, y: 1009, w: 45, h: 30, group: 'g1009'},
            {type: 't', x: 80,  y: 1009, w: 363, h: 30},
            {type: 'y', x: 765, y: 1048, w: 45, h: 30, group: 'g1048'},
            {type: 'y', x: 721, y: 1048, w: 45, h: 30, group: 'g1048'},
            {type: 't', x: 80,  y: 1048, w: 363, h: 30},
            {type: 'y', x: 765, y: 1108, w: 45, h: 30, group: 'g1108'},
            {type: 'y', x: 721, y: 1108, w: 45, h: 30, group: 'g1108'},
            {type: 't', x: 80,  y: 1108, w: 363, h: 30},
            {type: 'y', x: 765, y: 1149, w: 45, h: 30, group: 'g1149'},
            {type: 'y', x: 721, y: 1149, w: 45, h: 30, group: 'g1149'},
            {type: 't', x: 80,  y: 1149, w: 363, h: 30},
            {type: 'y', x: 765, y: 1187, w: 45, h: 30, group: 'g1187'},
            {type: 'y', x: 721, y: 1187, w: 45, h: 30, group: 'g1187'},
            {type: 't', x: 80,  y: 1187, w: 363, h: 30},
            {type: 'y', x: 765, y: 1217, w: 45, h: 30, group: 'g1217'},
            {type: 'y', x: 721, y: 1217, w: 45, h: 30, group: 'g1217'},
            {type: 't', x: 80,  y: 1217, w: 363, h: 30},
            {type: 'y', x: 765, y: 1247, w: 45, h: 30, group: 'g1247'},
            {type: 'y', x: 721, y: 1247, w: 45, h: 30, group: 'g1247'},
            {type: 't', x: 80,  y: 1247, w: 363, h: 30},
            {type: 'y', x: 765, y: 1286, w: 45, h: 30, group: 'g1286'},
            {type: 'y', x: 721, y: 1286, w: 45, h: 30, group: 'g1286'},
            {type: 't', x: 80,  y: 1286, w: 363, h: 30},
            {type: 'y', x: 765, y: 1355, w: 45, h: 30, group: 'g1355'},
            {type: 'y', x: 721, y: 1355, w: 45, h: 30, group: 'g1355'},
            {type: 't', x: 80,  y: 1355, w: 363, h: 30},
            {type: 'y', x: 765, y: 1385, w: 45, h: 30, group: 'g1385'},
            {type: 'y', x: 721, y: 1385, w: 45, h: 30, group: 'g1385'},
            {type: 't', x: 80,  y: 1385, w: 363, h: 30},
            {type: 't', x: 445, y: 1420, w: 340, h: 30, default: props.user.name, readonly: true},
            {type: 'i', x: 850, y: 1475, w: 250, h: 65, default: props.user.signature, readonly: true},
        ]
    },
    {
        text: 'صحيفة قياس للشبكة الهوائية',
        image: measurementsSheetForOHNetwork,
        fields: [
            {type: 't', x: 998, y: 240, w: 130, h: 25, default: props.dep, align: 'center'},
            {type: 't', x: 672, y: 240, w: 130, h: 25, default: props.div},
            {type: 't', x: 381, y: 230, w: 108, h: 25, default: props.district},
            {type: 't', x: 85, y: 243, w: 175, h: 25, default: props.number},
            {type: 't', x: 636, y: 333, w: 87, h: 25},
            {type: 't', x: 79 , y: 333, w: 70, h: 25},
            {type: 't', x: 636, y: 374, w: 87, h: 25},
            {type: 't', x: 79 , y: 374, w: 70, h: 25},
            {type: 't', x: 636, y: 414, w: 87, h: 25},
            {type: 't', x: 79 , y: 414, w: 70, h: 25},
            {type: 't', x: 636, y: 441, w: 87, h: 25},
            {type: 't', x: 79 , y: 441, w: 70, h: 25},
            {type: 't', x: 636, y: 474, w: 87, h: 25},
            {type: 't', x: 79 , y: 474, w: 70, h: 25},
            {type: 't', x: 636, y: 510, w: 87, h: 25},
            {type: 't', x: 79 , y: 510, w: 70, h: 25},
            {type: 't', x: 636, y: 555, w: 87, h: 25},
            {type: 't', x: 79 , y: 555, w: 70, h: 25},
            {type: 't', x: 636, y: 616, w: 87, h: 25},
            {type: 't', x: 79 , y: 616, w: 70, h: 25},
            {type: 't', x: 636, y: 675, w: 87, h: 25},
            {type: 't', x: 79 , y: 675, w: 70, h: 25},
            {type: 't', x: 636, y: 735, w: 87, h: 25},
            {type: 't', x: 79 , y: 735, w: 70, h: 25},
            {type: 't', x: 636, y: 793, w: 87, h: 25},
            {type: 't', x: 79 , y: 793, w: 70, h: 25},
            {type: 't', x: 636, y: 846, w: 87, h: 25},
            {type: 't', x: 79 , y: 846, w: 70, h: 25},
            {type: 't', x: 636, y: 899, w: 87, h: 25},
            {type: 't', x: 79 , y: 899, w: 70, h: 25},
            {type: 't', x: 636, y: 959, w: 87, h: 25},
            {type: 't', x: 79 , y: 959, w: 70, h: 25},
            {type: 't', x: 636, y: 1021, w: 87, h: 25},
            {type: 't', x: 79 , y: 1021, w: 70, h: 25},
            {type: 't', x: 636, y: 1086, w: 87, h: 25},
            {type: 't', x: 79 , y: 1086, w: 70, h: 25},
            {type: 't', x: 636, y: 1145, w: 87, h: 25},
            {type: 't', x: 79 , y: 1145, w: 70, h: 25},
            {type: 't', x: 636, y: 1189, w: 87, h: 25},
            {type: 't', x: 79 , y: 1189, w: 70, h: 25},
            {type: 't', x: 636, y: 1216, w: 87, h: 25},
            {type: 't', x: 79 , y: 1216, w: 70, h: 25},
            {type: 't', x: 636, y: 1250, w: 87, h: 25},
            {type: 't', x: 79 , y: 1250, w: 70, h: 25},
            {type: 't', x: 636, y: 1285, w: 87, h: 25},
            {type: 't', x: 79 , y: 1285, w: 70, h: 25},
            {type: 't', x: 636, y: 1313, w: 87, h: 25},
            {type: 't', x: 79 , y: 1313, w: 70, h: 25},
            {type: 'ta', x: 260, y: 1355, w: 795, h: 45},
            {type: 't', x: 610, y: 1407, w: 200, h: 25, default: props.user.name, readonly: true},
            {type: 'i', x: 395, y: 1395, w: 200, h: 52, default: props.user.signature, readonly: true},
        ]
    },
    {
        text: 'تقرير ملخص تنفيذ الخط الهوائي',
        image: overheadLineAsBuiltReportSummary,
        fields: [
            {type: 't', x: 995, y: 250, w: 200, h: 25, default: props.dep, align: 'center'},
            {type: 't', x: 130, y: 230, w: 270, h: 25, default: props.div, align: 'center'},
            {type: 't', x: 995, y: 380, w: 200, h: 25, default: props.number, align: 'center'},
            {type: 't', x: 765, y: 380, w: 200, h: 25, default: props.district, align: 'center'},
            {type: 't', x: 467, y: 380, w: 275, h: 25, default: props.contractor, align: 'center'},
            {type: 't', x: 361, y: 480, w: 100, h: 25, align: 'center'},
            {type: 't', x: 272, y: 480, w: 87, h: 25, align: 'center'},
            {type: 'y', x: 184, y: 480-9, w: 86, h: 41, group: 'g480'},
            {type: 'y', x: 81,  y: 480-9, w: 100, h: 41, group: 'g480'},
            {type: 't', x: 361, y: 533, w: 100, h: 25, align: 'center'},
            {type: 't', x: 272, y: 533, w: 87, h: 25, align: 'center'},
            {type: 'y', x: 184, y: 533-9, w: 86, h: 41, group: 'g533'},
            {type: 'y', x: 81,  y: 533-9, w: 100, h: 41, group: 'g533'},
            {type: 't', x: 361, y: 586, w: 100, h: 25, align: 'center'},
            {type: 't', x: 272, y: 586, w: 87, h: 25, align: 'center'},
            {type: 'y', x: 184, y: 586-9, w: 86, h: 41, group: 'g586'},
            {type: 'y', x: 81,  y: 586-9, w: 100, h: 41, group: 'g586'},
            {type: 't', x: 361, y: 640, w: 100, h: 25, align: 'center'},
            {type: 't', x: 272, y: 640, w: 87, h: 25, align: 'center'},
            {type: 'y', x: 184, y: 640-9, w: 86, h: 41, group: 'g640'},
            {type: 'y', x: 81,  y: 640-9, w: 100, h: 41, group: 'g640'},
            {type: 't', x: 361, y: 694, w: 100, h: 25, align: 'center'},
            {type: 't', x: 272, y: 694, w: 87, h: 25, align: 'center'},
            {type: 'y', x: 184, y: 694-9, w: 86, h: 41, group: 'g694'},
            {type: 'y', x: 81,  y: 694-9, w: 100, h: 41, group: 'g694'},
            {type: 't', x: 361, y: 748, w: 100, h: 25, align: 'center'},
            {type: 't', x: 272, y: 748, w: 87, h: 25, align: 'center'},
            {type: 'y', x: 184, y: 748-9, w: 86, h: 41, group: 'g748'},
            {type: 'y', x: 81,  y: 748-9, w: 100, h: 41, group: 'g748'},
            {type: 't', x: 361, y: 801, w: 100, h: 25, align: 'center'},
            {type: 't', x: 272, y: 801, w: 87, h: 25, align: 'center'},
            {type: 'y', x: 184, y: 801-9, w: 86, h: 41, group: 'g801'},
            {type: 'y', x: 81,  y: 801-9, w: 100, h: 41, group: 'g801'},
            {type: 't', x: 361, y: 859, w: 100, h: 25, align: 'center'},
            {type: 't', x: 272, y: 859, w: 87, h: 25, align: 'center'},
            {type: 'y', x: 184, y: 859-9, w: 86, h: 41, group: 'g859'},
            {type: 'y', x: 81,  y: 859-9, w: 100, h: 41, group: 'g859'},
            {type: 't', x: 361, y: 926, w: 100, h: 25, align: 'center'},
            {type: 't', x: 272, y: 926, w: 87, h: 25, align: 'center'},
            {type: 'y', x: 184, y: 926-9, w: 86, h: 41, group: 'g926'},
            {type: 'y', x: 81,  y: 926-9, w: 100, h: 41, group: 'g926'},
            {type: 't', x: 361, y: 1008, w: 100, h: 25, align: 'center'},
            {type: 't', x: 272, y: 1008, w: 87, h: 25, align: 'center'},
            {type: 'y', x: 184, y: 1008-9, w: 86, h: 41, group: 'g1008'},
            {type: 'y', x: 81,  y: 1008-9, w: 100, h: 41, group: 'g1008'},
            {type: 't', x: 361, y: 1088, w: 100, h: 25, align: 'center'},
            {type: 't', x: 272, y: 1088, w: 87, h: 25, align: 'center'},
            {type: 'y', x: 184, y: 1088-9, w: 86, h: 41, group: 'g1088'},
            {type: 'y', x: 81,  y: 1088-9, w: 100, h: 41, group: 'g1088'},
            {type: 't', x: 361, y: 1149, w: 100, h: 25, align: 'center'},
            {type: 't', x: 272, y: 1149, w: 87, h: 25, align: 'center'},
            {type: 'y', x: 184, y: 1149-9, w: 86, h: 41, group: 'g1149'},
            {type: 'y', x: 81,  y: 1149-9, w: 100, h: 41, group: 'g1149'},
            {type: 't', x: 361, y: 1193, w: 100, h: 25, align: 'center'},
            {type: 't', x: 272, y: 1193, w: 87, h: 25, align: 'center'},
            {type: 'y', x: 184, y: 1193-9, w: 86, h: 41, group: 'g1193'},
            {type: 'y', x: 81,  y: 1193-9, w: 100, h: 41, group: 'g1193'},
            {type: 't', x: 361, y: 1237, w: 100, h: 25, align: 'center'},
            {type: 't', x: 272, y: 1237, w: 87, h: 25, align: 'center'},
            {type: 'y', x: 184, y: 1237-9, w: 86, h: 41, group: 'g1237'},
            {type: 'y', x: 81,  y: 1237-9, w: 100, h: 41, group: 'g1237'},
            {type: 't', x: 550, y: 1280, w: 200, h: 25, default: props.user.name, readonly: true},
            {type: 'i', x: 340, y: 1271, w: 200, h: 52, default: props.user.signature, readonly: true},
        ]
    },
    {
        text: 'نموذج مسح موقع',
        image: siteSurveyForm,
        fields: [
            {type: 't', x: 715, y: 288, w: 325, h: 25, default: props.number},
            {type: 't', x: 140, y: 288, w: 490, h: 25, default: props.contractor},
            {type: 't', x: 715, y: 375, w: 330, h: 25, default: props.feeder},
            {type: 't', x: 140, y: 375, w: 425, h: 25, default: props.now_date},
            {type: 'y', x: 713, y: 487, w: 83, h: 57, group: 'g487'},
            {type: 'y', x: 629, y: 487, w: 79, h: 57, group: 'g487'},
            {type: 't', x: 130, y: 487, w: 494, h: 57, align: 'center'},
            {type: 'y', x: 713, y: 549, w: 83, h: 57, group: 'g549'},
            {type: 'y', x: 629, y: 549, w: 79, h: 57, group: 'g549'},
            {type: 't', x: 130, y: 549, w: 494, h: 57, align: 'center'},
            {type: 'y', x: 713, y: 610, w: 83, h: 57, group: 'g610'},
            {type: 'y', x: 629, y: 610, w: 79, h: 57, group: 'g610'},
            {type: 't', x: 130, y: 610, w: 494, h: 57, align: 'center'},
            {type: 'y', x: 713, y: 672, w: 83, h: 57, group: 'g672'},
            {type: 'y', x: 629, y: 672, w: 79, h: 57, group: 'g672'},
            {type: 't', x: 130, y: 672, w: 494, h: 57, align: 'center'},
            {type: 'y', x: 713, y: 734, w: 83, h: 57, group: 'g734'},
            {type: 'y', x: 629, y: 734, w: 79, h: 57, group: 'g734'},
            {type: 't', x: 130, y: 734, w: 494, h: 57, align: 'center'},
            {type: 'y', x: 713, y: 796, w: 83, h: 57, group: 'g796'},
            {type: 'y', x: 629, y: 796, w: 79, h: 57, group: 'g796'},
            {type: 't', x: 130, y: 796, w: 494, h: 57, align: 'center'},
            {type: 'y', x: 713, y: 857, w: 83, h: 57, group: 'g857'},
            {type: 'y', x: 629, y: 857, w: 79, h: 57, group: 'g857'},
            {type: 't', x: 130, y: 857, w: 494, h: 57, align: 'center'},
            {type: 'y', x: 713, y: 919, w: 83, h: 57, group: 'g919'},
            {type: 'y', x: 629, y: 919, w: 79, h: 57, group: 'g919'},
            {type: 't', x: 130, y: 919, w: 494, h: 57, align: 'center'},
            {type: 't', x: 802, y: 1040, w: 216, h: 25, default: props.supervisor.name, readonly: true},
            {type: 't', x: 136, y: 1040, w: 476, h: 25, default: props.user.name, readonly: true},
            {type: 'i', x: 772, y: 1110, w: 200, h: 52, default: props.supervisor.signature, readonly: true},
            {type: 'i', x: 355, y: 1110, w: 200, h: 52, default: props.user.signature, readonly: true},
            {type: 'ta', x: 132, y: 1241, w: 1035, h: 247},
        ]
    },
    {
        text: 'أصول',
        image: assets,
        fields: [
            {type: 't', x: 284, y: 241, w: 183, h: 25, default: props.contractor, fontSize: 10, align: 'left'},
            {type: 't', x: 655, y: 241, w: 183, h: 25, default: props.number, fontSize: 10, align: 'left'},
            {type: 't', x: 1027, y: 241, w: 183, h: 25, default: 'MZ', fontSize: 10, align: 'left'},
            {type: 't', x: 284, y: 299, w: 183, h: 25, default: props.functional_location, fontSize: 10, align: 'left'},
            {type: 't', x: 655, y: 299, w: 183, h: 25, default: props.equipment_no, fontSize: 10, align: 'left'},
            {type: 't', x: 1027, y: 299, w: 183, h: 25, default: props.feeder, fontSize: 10, align: 'left'},
            {type: 't', x: 284, y: 329, w: 183, h: 25, default: props.x, fontSize: 10, align: 'left'},
            {type: 't', x: 655, y: 329, w: 183, h: 25, default: props.y, fontSize: 10, align: 'left'},

            {type: 'y', x: 852, y: 455, w: 65, h: 29, group: 'g455'},
            {type: 'y', x: 1059, y: 455, w: 65, h: 29, group: 'g455'},
            {type: 'y', x: 852, y: 516, w: 65, h: 29, group: 'g516'},
            {type: 'y', x: 1059, y: 516, w: 65, h: 29, group: 'g516'},
            {type: 'y', x: 852, y: 573, w: 65, h: 29, group: 'g573'},
            {type: 'y', x: 1059, y: 573, w: 65, h: 29, group: 'g573'},
            {type: 'y', x: 852, y: 629, w: 65, h: 29, group: 'g629'},
            {type: 'y', x: 1059, y: 629, w: 65, h: 29, group: 'g629'},
            {type: 'y', x: 852, y: 688, w: 65, h: 29, group: 'g688'},
            {type: 'y', x: 1059, y: 688, w: 65, h: 29, group: 'g688'},
            {type: 'y', x: 852, y: 745, w: 65, h: 29, group: 'g745'},
            {type: 'y', x: 1059, y: 745, w: 65, h: 29, group: 'g745'},
            {type: 'y', x: 852, y: 799, w: 65, h: 29, group: 'g799'},
            {type: 'y', x: 1059, y: 799, w: 65, h: 29, group: 'g799'},
            {type: 'y', x: 852, y: 858, w: 65, h: 29, group: 'g858'},
            {type: 'y', x: 1059, y: 858, w: 65, h: 29, group: 'g858'},
            {type: 'y', x: 852, y: 918, w: 65, h: 29, group: 'g918'},
            {type: 'y', x: 1059, y: 918, w: 65, h: 29, group: 'g918'},
            {type: 'y', x: 852, y: 976, w: 65, h: 29, group: 'g976'},
            {type: 'y', x: 1059, y: 976, w: 65, h: 29, group: 'g976'},
            {type: 'y', x: 852, y: 1046, w: 65, h: 29, group: 'g1046'},
            {type: 'y', x: 1059, y: 1046, w: 65, h: 29, group: 'g1046'},
            {type: 'y', x: 852, y: 1133, w: 65, h: 29, group: 'g1133'},
            {type: 'y', x: 1059, y: 1133, w: 65, h: 29, group: 'g1133'},
            {type: 'y', x: 852, y: 1223, w: 65, h: 29, group: 'g1223'},
            {type: 'y', x: 1059, y: 1223, w: 65, h: 29, group: 'g1223'},
            {type: 'y', x: 852, y: 1305, w: 65, h: 29, group: 'g1305'},
            {type: 'y', x: 1059, y: 1305, w: 65, h: 29, group: 'g1305'},

            {type: 't', x: 180, y: 513, w: 200, h: 40, default: props.equipment_no, fontSize: 14, align: 'center'},
            {type: 't', x: 180, y: 743, w: 200, h: 40, default: props.equipment_no, fontSize: 14, align: 'center'},
            {type: 't', x: 180, y: 853, w: 200, h: 40, default: props.equipment_no, fontSize: 14, align: 'center'},
            {type: 't', x: 180, y: 1083, w: 200, h: 40, default: props.equipment_no, fontSize: 14, align: 'center'},

            {type: 't', x: 282, y: 1393, w: 183, h: 25, align: 'left', fontSize: 10, default: props.contractor},
            {type: 't', x: 282, y: 1421, w: 183, h: 25, align: 'left', fontSize: 10, default: props.supervisor.name, readonly: true},
            {type: 'i', x: 305, y: 1444, w: 138, h: 36, default: props.supervisor.signature, readonly: true},
            {type: 't', x: 282, y: 1478, w: 183, h: 25, align: 'left', fontSize: 10, default: props.now_date},

            {type: 't', x: 623, y: 1393, w: 183, h: 25, align: 'left', fontSize: 10, default: 'MZ'},
            {type: 't', x: 623, y: 1421, w: 183, h: 25, align: 'left', fontSize: 10, default: props.user.name, readonly: true},
            {type: 'i', x: 665, y: 1444, w: 138, h: 36, default: props.user.signature, readonly: true},
            {type: 't', x: 623, y: 1478, w: 183, h: 25, align: 'left', fontSize: 10, default: props.now_date},

            {type: 't', x: 995, y: 1393, w: 214, h: 25, align: 'left', fontSize: 10},
            {type: 't', x: 995, y: 1421, w: 214, h: 25, align: 'left', fontSize: 10},
            {type: 't', x: 995, y: 1450, w: 214, h: 25, align: 'left', fontSize: 10},
            {type: 't', x: 995, y: 1478, w: 214, h: 25, align: 'left', fontSize: 10},
        ]
    },
]